/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface StorageControllerRenderImage$Params {
  id: string;
  width: number;
  height: number;
  fit?: 'contain' | 'cover';
}

export function storageControllerRenderImage(http: HttpClient, rootUrl: string, params: StorageControllerRenderImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, storageControllerRenderImage.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('width', params.width, {});
    rb.query('height', params.height, {});
    rb.query('fit', params.fit, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

storageControllerRenderImage.PATH = '/api/storage/{id}/render';
